module.exports = __webpack_public_path__ + "static/express-d638bd34b425dec39792d4a81189eddf.png";